/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconEgg: {
  name: 'egg';
  data: string;
} = {
  name: 'egg',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 612 612"><path d="M91.333 256.208c-7.172 0-14.344 14.344-14.344 23.906 0 7.172 4.781 14.344 14.344 14.344s14.344-7.172 14.344-14.344c0-9.562-7.172-23.906-14.344-23.906z" transform="matrix(15 0 0 15 -1064 -3824)"/></svg>`,
};
